import {useCallback, useEffect} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getNotificationStatisticById} from 'src/openapi/admin/apis/SsoDraftsApi';
import {useAppDispatch} from 'src/store/hooks';

import type {DraftNotificationStatistics} from 'src/openapi/admin/models/DraftNotificationStatistics';

export const useGetNotificationStatisticById = (draftId: number) => {
    const dispatch = useAppDispatch();

    const getDispatchAction = useCallback(
        (signal: AbortSignal) => dispatch(getNotificationStatisticById({draftId}, {signal})),
        [draftId, dispatch],
    );

    const dataHook = useReadOnlyDataHook<DraftNotificationStatistics | null>({
        getDispatchAction,
        initValue: null,
        shouldLoadData: false,
    });

    const {loadData} = dataHook;

    useEffect(() => {
        if (draftId > 0) {
            loadData();
        }
    }, [draftId, loadData]);

    return dataHook;
};
